import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = ["aria-valuenow"]
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  class: "w-4 h-4"
}
const _hoisted_4 = { class: "text-xs font-medium hidden sm:block" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'StepIndicator',
  props: {
    currentStep: {},
    totalSteps: {},
    stepLabels: {}
  },
  setup(__props: any) {

const props = __props

const progress = computed(() => {
  const total = props.totalSteps || props.stepLabels.length || 1
  return ((props.currentStep + 1) / total) * 100
})

const columnCount = computed(() => props.stepLabels.length || props.totalSteps || 1)
const gridTemplate = computed(() => `repeat(${columnCount.value}, minmax(0, 1fr))`)

const isComplete = (index: number) => index < props.currentStep
const isCurrent = (index: number) => index === props.currentStep

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "relative w-full h-2 bg-primary/20 overflow-hidden rounded-full",
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": progress.value
    }, [
      _createElementVNode("div", {
        class: "h-full bg-brand transition-all duration-300 ease-in-out",
        style: _normalizeStyle({ width: `${progress.value}%` })
      }, null, 4)
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: "grid gap-2",
      style: _normalizeStyle({ gridTemplateColumns: gridTemplate.value })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepLabels, (label, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["flex flex-col items-center gap-2 text-center", {
          'text-foreground': isCurrent(index),
          'text-muted-foreground': isComplete(index),
          'text-muted-foreground/50': !isCurrent(index) && !isComplete(index),
        }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex w-8 h-8 items-center justify-center rounded-full border-2 text-sm font-medium transition-colors", {
            'border-brand bg-brand text-white': isCurrent(index) || isComplete(index),
            'border-muted-foreground/30': !isCurrent(index) && !isComplete(index),
          }])
          }, [
            (isComplete(index))
              ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[0] || (_cache[0] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M5 13l4 4L19 7"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(index + 1), 1)
                ], 64))
          ], 2),
          _createElementVNode("span", _hoisted_4, _toDisplayString(label), 1)
        ], 2))
      }), 128))
    ], 4)
  ]))
}
}

})